import React from 'react';
import { Row, Col, Typography, Space, Divider } from 'antd';
import LogViewer from '../components/LogViewer';

const { Title, Paragraph } = Typography;

const Logs = () => {
  return (
    <div style={{ padding: '24px' }}>
      <Row gutter={[24, 24]}>
        <Col span={24}>
          <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <div>
              <Title level={2}>Log Service (WebSocket Disabled)</Title>
              <Paragraph type="secondary">
                WebSocket connection is disabled. Currently only supports local log testing and display.
                Contact the administrator to re-enable remote log reception.
              </Paragraph>
            </div>

            <Divider />

            {/* WebSocket日志功能已关闭 */}
            {/* <LogViewer 
              serverUrl="ws://localhost:3001" 
              height={500}
            /> */}

            <div>
              <Title level={4}>Feature Status</Title>
              <ul>
                <li><strong>WebSocket Connection:</strong> Disabled - no longer connects to remote log server</li>
                <li><strong>Local Logs:</strong> Only supports local test log generation and display</li>
                <li><strong>Auto Scroll:</strong> When enabled, new logs automatically scroll to the bottom</li>
                <li><strong>Pause/Resume:</strong> Pause log display updates for reviewing historical logs</li>
                <li><strong>Search Filter:</strong> Enter keywords in the search box to filter displayed logs</li>
                <li><strong>Clear Logs:</strong> Clear all currently displayed log records</li>
                <li><strong>Export Logs:</strong> Export current logs as a text file</li>
              </ul>
            </div>

            <div>
              <Title level={4}>Log Processing Mode</Title>
              <Paragraph>
                This log service uses <strong>receive-only mode</strong>:
              </Paragraph>
              <ul>
                <li><strong>Receive Remote Logs:</strong> Receives string messages and structured logs from remote servers</li>
                <li><strong>Local Display:</strong> Displays in real-time in browser console.log and on the page</li>
                <li><strong>Local Processing:</strong> Supports search, filter, export and other local operations</li>
                <li><strong>No Relay:</strong> All logs are processed locally only, never sent back to remote servers</li>
              </ul>
            </div>

            <div>
              <Title level={4}>Supported Message Formats</Title>
              <Paragraph>
                The log service supports receiving the following remote message formats:
              </Paragraph>
              <ul>
                <li><strong>String Messages:</strong> Direct string content</li>
                <li><strong>JSON Objects:</strong> Objects containing a message field, or complete JSON data</li>
                <li><strong>Log Objects:</strong> Structured logs containing level, timestamp and other fields</li>
              </ul>
            </div>
          </Space>
        </Col>
      </Row>
    </div>
  );
};

export default Logs; 